import React from 'react';
import { List, Edit, Create, Datagrid, SimpleForm, required,
		TextField, BooleanField, UrlField, NumberField,
		TextInput, BooleanInput, NumberInput, SelectInput, ReferenceInput, LongTextInput, DisabledInput,
		EditButton, DeleteButton,CreateButton,TabbedForm, FormTab, ReferenceManyField  } from 'admin-on-rest';
import AdsByDomain from './AdsByDomain';

import { FieldTypes } from '../utils/enums';
import CHEditPlanfieldField from '../utils/CHEditPlanfieldField';

export const CloudhintsdomainList = (props) => (
    <List title="Cloudhints - Websites" perPage={50} {...props}>
        <Datagrid perPage={50}>
            <NumberField source="sortorder" label="Vlg" sortable={false} />
            <TextField source="title" sortable={false} />
            <UrlField source="website_url" sortable={false} />
            <TextField source="minimum_cpc" label="Min CPC" sortable={false} />
            <BooleanField source="subscribe_active" label="Actief" sortable={false} />
            <NumberField source="monthlyvisits" label="Bezoekers" sortable={false} />
            <AdsByDomain />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const CloudhintsdomainCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
			<strong>Algemeen</strong>
            <TextInput source="title" label="Titel, vb: www.vergelijk-boekhoudprogramma.nl" />
            <TextInput source="website_url" label="Volledige URL incl. https://" />	
			<TextInput source="description" label="Omschrijving van ca 2 regels" />	
            <NumberInput step='5' source="sortorder" label="Volgorde, hoger getal is hoger in lijsten" />
			
			<span><br/><br/></span>
			<strong>CPC</strong>
			<NumberInput source="minimum_cpc" />
			
			<span><br/><br/></span>
			<strong>Bezoekers per maand</strong>
			<NumberInput source="monthlyvisits" />
			<TextInput source="monthlyvisits_disp" label="Maandelijks bezoekers weergave (vb: 5000+)" />	
			
			<span><br/><br/></span>
			<strong>Actief?</strong>
			<BooleanInput label="Gebruikers kunnen zich aanmelden voor de site?" source="subscribe_active" />	
        </SimpleForm>
    </Create>
);

export const CloudhintsdomainEdit = (props) => (
    <Edit title="Edit" {...props}>
        <TabbedForm contentContainerClassName="class-container-tab">
        	<FormTab label="Algemeen">
				<strong>Algemeen</strong>
				<TextInput source="title" label="Titel, vb: www.vergelijk-boekhoudprogramma.nl" />
				<TextInput source="website_url" label="Volledige URL incl. https://" />	
				<TextInput source="description" label="Omschrijving van ca 2 regels" />	
				<NumberInput step='5' source="sortorder" label="Volgorde, hoger getal is hoger in lijsten" />
				
				<span><br/><br/></span>
				<strong>CPC</strong>
				<NumberInput source="minimum_cpc" />
				
				<span><br/><br/></span>
				<strong>Bezoekers per maand</strong>
				<NumberInput source="monthlyvisits" />
				<TextInput source="monthlyvisits_disp" label="Maandelijks bezoekers weergave (vb: 5000+)" />	
				
				<span><br/><br/></span>
				<strong>Actief?</strong>
				<BooleanInput label="Gebruikers kunnen zich aanmelden voor de site?" source="subscribe_active" />	
        
            </FormTab>
			<FormTab label="Vragenlijst pakketten">
				<a href={`/#/admin/planfield/create?cloudhintsdomains_id=${window.location.href.substring(window.location.href.lastIndexOf('\/')+1)}`}>Nieuw veld</a>
				<ReferenceManyField reference="admin/planfield" source="cloudhintsdomains_id" target="cloudhintsdomains_id" label="Velden" addLabel={true} perPage={50}>
					<Datagrid>
						<NumberField source="field_maxlength" sortable={false} />
						<NumberField source="field_order" sortable={false} />
						
						<TextField source="field_label" sortable={false}  />
						<TextField source="field_key"  sortable={false} />
						<TextField source="field_type" sortable={false} />
						
						<BooleanField source="field_required" sortable={false} />
						<CHEditPlanfieldField source="id" sortable={false} />
					</Datagrid>
				</ReferenceManyField>
            </FormTab>
        </TabbedForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/cloudhints_domains/Cloudhintsdomains.js